"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardIcon = CardIcon;
var _server = require("@whitbread-eos/utils/server");
var _image = _interopRequireDefault(require("next/image"));
var _jsxRuntime = require("react/jsx-runtime");
var CardMapping = {
  AC: 'mastercard',
  AM: 'amex',
  AT: 'piba',
  DI: 'dinners',
  DL: 'visa',
  EL: 'visa',
  MA: 'mastercard',
  VI: 'visa',
  MC: 'mastercard',
  AX: 'amex',
  PI: 'piba',
  DN: 'dinners',
  VS: 'visa',
  BD: 'piba',
  PE: 'piba'
};
function CardIcon(_ref) {
  var {
    type,
    className,
    icons
  } = _ref;
  var url = icons["icon.payment.".concat(CardMapping[type] || type)];
  if (url) {
    return (0, _jsxRuntime.jsx)(_image.default, {
      "data-testid": "CardIcon",
      className: className,
      src: (0, _server.formatIBAssetsUrl)(url),
      alt: "card-icon",
      width: 40,
      height: 24
    });
  }
  return (0, _jsxRuntime.jsx)("div", {
    "data-testid": "CardIcon",
    className: (0, _server.cn)(cardIconStyle, className)
  });
}
var cardIconStyle = 'bg-lightGrey3 min-w-[40px] min-h-[24px]';